package com.kinoshazam.update

data class ProgressEntity(
    val downloaded: Long,
    val total: Long,
) {

    val percent get() = if (total > 0L) ((downloaded * 100) / total).toInt() else 0
}
